import { BaseApiSelector } from "@bornfight/aardvark";
import { ResourceType } from "enums/ResourceType";
import { ProgramTemplateJSONAModel } from "interfaces/jsona-models/ProgramTemplateJSONAModel";

export class ProgramTemplateSelector extends BaseApiSelector<ProgramTemplateJSONAModel> {
  constructor() {
    super(ResourceType.ProgramTemplate);
  }
}
